import { nextTick } from "vue";
import type { RouteLocationNormalized } from "vue-router";

export function normalizeParamId(value: unknown): string | undefined {
  if (typeof value === "string") return value;
  if (Array.isArray(value) && typeof value[0] === "string") return value[0];
  return undefined;
}

export async function scrollToHashOrTop(to: RouteLocationNormalized): Promise<void> {
  await nextTick();

  const hash = to.hash;
  if (hash) {
    const target = document.querySelector(hash);
    if (target) {
      (target as HTMLElement).scrollIntoView({ behavior: "auto" });
      return;
    }
    // Retry once in case DOM finishes resolving after tick
    window.location.hash = hash;
    return;
  }

  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
}
